import { useLocation, useHistory } from "react-router-dom";
import qs from "query-string";

export function useURLParamsUpdater() {
  const location = useLocation();
  const history = useHistory();

  const updateURLParams = (newParams = {}) => {
    const currentParams = qs.parse(location.search);

    const updatedParams = {
      ...currentParams,
      ...newParams,
    };

    // Remove keys with null/undefined
    Object.keys(updatedParams).forEach((key) => {
      if (updatedParams[key] === null || updatedParams[key] === undefined) {
        delete updatedParams[key];
      }
    });

    const newSearch = qs.stringify(updatedParams);
    history.replace(`${location.pathname}?${newSearch}`);
  };

  return updateURLParams;
}
